<template>
  <section class="wood-materials-price-banner" v-if="hasPrices">
    <div class="banner d-flex flex-column flex-md-row-reverse">
      <div
        class="banner__content d-flex justify-content-center align-items-center align-items-md-start flex-column text-center text-md-left"
      >
        <h2 class="banner__title">
          {{ t('banners.woodMaterialsPrice.title') }}
        </h2>
        <!--        <div class="banner__columns">-->
        <div>
          <p class="banner__text banner__text--requirements">
            {{ t('banners.woodMaterialsPrice.requirements') }}
            <strong class="banner__requirements">{{ results.wood_materials_requirement }} m³</strong>
            <br />
            {{ t('banners.woodMaterialsPrice.requirementsInfo') }}
          </p>
          <p class="banner__text">
            {{ t('banners.woodMaterialsPrice.description') }}
          </p>
          <div class="banner__price">
            <strong>
              {{ results.wood_materials_price.min }} –
              <wbr />
              {{ results.wood_materials_price.max }}
              <span>*</span>
            </strong>
          </div>
          <template v-if="results?.wood_working_price?.min && results?.wood_working_price?.max">
            <p class="banner__text">
              {{ t('banners.woodMaterialsPrice.woodworking') }}
            </p>
            <div class="banner__price">
              <strong>
                {{ results.wood_working_price.min }} –
                <wbr />
                {{ results.wood_working_price.max }}
                <span>*</span>
              </strong>
            </div>
          </template>
        </div>
        <div>
          <p class="banner__text" v-html="t('banners.woodMaterialsPrice.requestOffer')" />
          <p class="banner__info">
            {{ t('banners.woodMaterialsPrice.info') }}
          </p>
          <p class="banner__link">
            <a :href="t('banners.woodMaterialsPrice.cta.link')" target="_blank" class="btn btn-white">
              {{ t('banners.woodMaterialsPrice.cta.label') }}
            </a>
          </p>
        </div>
      </div>
    </div>
    <!--    </div>-->
  </section>
</template>

<script>
import { defineComponent } from 'vue'
import { useI18n } from 'vue-i18n'

export default defineComponent({
  name: 'WoodMaterialsPriceBanner',
  props: {
    results: {
      type: Object,
      default: () => ({})
    }
  },
  setup(props) {
    const { t } = useI18n()

    const hasPrices = props.results?.wood_materials_price?.min && props.results?.wood_materials_price?.max

    return {
      hasPrices,
      t
    }
  }
})
</script>

<style lang="scss" scoped>
@use '@/assets/style/base/variables' as *;

.wood-materials-price-banner {
  background: $dark-blue;
  color: $white;
  //margin-top: 65px;
  margin-top: 24px;
  height: 100%;

  @media (min-width: 768px) {
    //margin: 75px 0;
    background: $dark-blue url('@/assets/images/summary/wood-materials-price-banner.jpg') no-repeat right top;
  }
}

.banner {
  &__content {
    padding: 20px 20px 40px;

    @media (min-width: 768px) {
      padding: 32px 30px;
    }

    > div.col-lg-6 {
      height: 100%;
    }
  }

  &__title {
    color: $light-blue;
    font-size: 24px;
    margin-bottom: 28px;
  }

  &__text {
    font-size: 14px;
    margin-bottom: 10px;

    &--requirements {
      margin-bottom: 20px;
    }
  }

  &__requirements {
    font-weight: bold;
    white-space: nowrap;
    font-size: 18px;
  }

  &__price {
    font-size: 30px;
    white-space: nowrap;
    line-height: 1.25;
    margin-bottom: 10px;

    @media (min-width: 992px) {
      font-size: 36px;
      margin-bottom: 5px;
    }
  }

  &__info {
    font-size: 14px;
    margin-bottom: 20px;
  }

  &__link {
    margin-bottom: 0;
  }

  &__image {
    object-fit: cover;

    @media (max-width: 767px) {
      max-height: 200px;
    }

    @media (min-width: 768px) {
      flex: 0 0 360px;
      max-width: 360px;
    }
  }
}

//.banner__columns {
//  display: flex;
//  gap: 40px 80px;
//
//  @media (max-width: 767px) {
//    flex-direction: column;
//  }
//
//  > div {
//    flex: 1 1 100%;
//
//    @media (min-width: 768px) {
//      max-width: 50%;
//    }
//  }
//}
</style>
